"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarrierSelect = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
function CarrierSelect(props) {
    var onChange = props.onChange, value = props.value, disabled = props.disabled, name = props.name, innerRef = props.innerRef, showSelectAnOption = props.showSelectAnOption, _a = props.data, data = _a === void 0 ? [] : _a;
    var carrierOptions = data
        ? lodash_1.uniq(data)
            .map(function (carrier) { return ({
            value: carrier.id,
            label: carrier.name,
        }); })
            .sort(core_ui_1.sortByLabel)
        : [];
    return (react_1.default.createElement(core_ui_1.SelectInput, { name: name, options: carrierOptions, onChange: function (carrier) {
            if (onChange)
                onChange(carrier);
        }, value: value, innerRef: innerRef, disabled: disabled, showSelectAnOption: showSelectAnOption }));
}
exports.CarrierSelect = CarrierSelect;
